import React from 'react';
import "./work.css";

const Etcpage = () => {
  return (
	<>
      <div className="workshop test">
        <a href="https://www.canva.com/design/DAFaEeydXmo/K-5_-d_b4DZ0KmuA2tndEQ/view?utm_content=DAFaEeydXmo&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink" target="_blank" rel="noreferrer">
          <div className="wrk1">
            <div className="github">
              <img className="git_logo" src="./image/photoshop.png" alt="" />
            </div>
            <img src="./image/folder.png" alt="" />
            <span>Graphic Design</span>
          </div>
        </a>
        <a href="https://www.youtube.com/channel/UCw1UQFNbBOVZu089MIuGgLg" target="_blank" rel="noreferrer">
          <div className="wrk1">
            <div className="github">
              <img className="git_logo" src="./image/music.png" alt="" />
            </div>
            <img src="./image/folder.png" alt="" />
            <span>terra</span>
          </div>
        </a>

       
      </div>
    </>
  );
};

export default Etcpage
